function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1F4F5"
    },
    d: "M720.621,284.243c0-98.97-80.231-179.201-179.201-179.201c-3.655,0-7.281,0.123-10.882,0.338 c-39.368-47.119-98.56-77.103-164.763-77.103c-101.103,0-185.862,69.918-208.601,164.036 c-59.777,16.694-103.63,71.549-103.63,136.651c0,38.992,15.734,74.307,41.195,99.952h552.427 C691.696,396.314,720.621,343.66,720.621,284.243z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EE6E0"
    },
    d: "M712.019,444.833L712.019,444.833c0-1.749-1.418-3.167-3.167-3.167h-22.019 c-1.749,0-3.167-1.418-3.167-3.167l0,0c0-1.749-1.418-3.167-3.167-3.167h-5.872c-1.749,0-3.167-1.418-3.167-3.167l0,0 c0-1.749-1.418-3.167-3.167-3.167H81.706c-1.749,0-3.167,1.418-3.167,3.167l0,0c0,1.749-1.418,3.167-3.167,3.167H69.5 c-1.749,0-3.167,1.418-3.167,3.167l0,0c0,1.749-1.418,3.167-3.167,3.167H41.148c-1.749,0-3.167,1.418-3.167,3.167l0,0 c0,1.749,1.418,3.167,3.167,3.167h200.029c1.749,0,3.167,1.418,3.167,3.167l0,0c0,1.749-1.418,3.167-3.167,3.167H129.65 c-1.749,0-3.167,1.418-3.167,3.167l0,0c0,1.749,1.418,3.167,3.167,3.167h545.548c1.749,0,3.167-1.418,3.167-3.167l0,0 c0-1.749-1.418-3.167-3.167-3.167H567.695c-1.749,0-3.167-1.418-3.167-3.167l0,0c0-1.749,1.418-3.167,3.167-3.167h141.157 C710.601,448,712.019,446.582,712.019,444.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EE6E0"
    },
    d: "M108.732,460.667H83.066c-1.749,0-3.167-1.418-3.167-3.167l0,0c0-1.749,1.418-3.167,3.167-3.167 h25.667c1.749,0,3.167,1.418,3.167,3.167l0,0C111.899,459.249,110.481,460.667,108.732,460.667z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "442.911,340.774 437.994,340.774 436.679,352.562 441.912,349.736  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "436.679,352.562 428.327,427.441 433.245,427.441 441.912,349.736  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "479.577,351.253 471.079,427.441 475.996,427.441 484.809,348.426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "485.663,340.774 480.746,340.774 479.577,351.253 484.809,348.426  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "504.164,340.774 499.247,340.774 500.447,351.528 505.084,349.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "513.831,427.441 505.084,349.023 500.447,351.528 508.914,427.441  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "546.916,340.774 541.999,340.774 543.117,350.806 547.755,348.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "556.582,427.441 547.755,348.3 543.117,350.806 551.665,427.441  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797C99"
    },
    d: "M434.454,340.774l0.001-0.002c4.466-9.666,14.143-15.855,24.792-15.855h32.541l17.595-114.523 l24.722-19.995h15.656c19.61,0,34.607,17.477,31.629,36.859l-14.834,96.553c-1.499,9.759-9.895,16.963-19.768,16.963H434.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M418.798,340.774l0.001-0.002c4.466-9.666,14.143-15.855,24.792-15.855h32.541l15.002-97.644 c3.259-21.213,21.51-36.874,42.971-36.874h0c19.61,0,34.607,17.477,31.629,36.859l-13.18,85.785 c-1.049,6.831-6.927,11.874-13.838,11.874h-20.527c-10.648,0-20.325,6.189-24.792,15.855l-0.001,0.002H418.798z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M465.528,190.483c4.781,2.353,10.675,2.3,15.413-0.141c3.67-1.89,6.57-5.179,8.094-9.009 h-3.868c-2.209,0-4-1.791-4-4V164l-17.25,4.5v9.667c0,2.209-1.791,4-4,4h-2.409 C459.148,185.732,462.002,188.748,465.528,190.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M481.167,164c-2.917,10.417-8.917,14.75-17.25,11.833V168.5L481.167,164z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M447.917,149c-6.75-5.083-4.5-15.5-3.5-17c-2.43-1.458-4.795-3.439-6.226-5.886 c-1.431-2.446-1.975-5.502-1.02-8.171c0.955-2.668,3.57-4.783,6.404-4.734c3.306,0.058,5.922,2.759,9.045,3.844 c3.156,1.096,6.633,0.477,9.867-0.363c3.234-0.84,6.502-1.901,9.834-1.655c2.827,0.209,5.572,1.393,7.664,3.306 c2.092,1.913,3.517,4.541,3.978,7.338c2.697-1.293,6.464-0.268,8.118,2.223c1.593,2.399,1.357,5.534,0.976,8.389 c-0.689,5.167-3.489,17.643-4.724,22.707L479,161.333L447.917,149z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M485.526,151.67c0.888-1.42,2.21-2.628,3.82-3.089c1.611-0.461,3.512-0.059,4.596,1.218 c0.907,1.068,1.141,2.59,0.889,3.968c-0.251,1.378-0.935,2.638-1.697,3.814c-0.691,1.067-1.464,2.097-2.445,2.906 c-0.981,0.809-2.189,1.386-3.459,1.438c-1.27,0.052-2.593-0.477-3.332-1.511c-0.837-1.172-0.604-2.824-0.223-4.129 C484.135,154.707,484.65,153.07,485.526,151.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE7274"
    },
    d: "M487.059,159.928c-0.638,0-1.24-0.266-1.534-0.678c-0.135-0.189-0.397-0.801,0.07-2.406 c0.418-1.434,0.889-2.933,1.627-4.114c0.707-1.131,1.682-1.942,2.674-2.226c0.249-0.071,0.511-0.107,0.779-0.107 c0.721,0,1.373,0.26,1.743,0.697c0.44,0.519,0.611,1.405,0.445,2.313c-0.204,1.126-0.86,2.241-1.408,3.087 c-0.739,1.142-1.367,1.897-2.038,2.45c-0.732,0.604-1.538,0.952-2.269,0.982L487.059,159.928z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M482.417,147.833c0,0-8-3.333-6.939-12.738c-8.374,2.679-17.633,2.459-25.89-0.551 c-1.84,2.968-2.921,6.456-2.921,10.205v9.333c0,10.724,8.693,19.417,19.417,19.417h0c8.868,0,16.331-5.951,18.654-14.073 c-0.515-0.555-0.996-1.142-1.399-1.796C481.602,154.809,481.178,150.907,482.417,147.833z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M451.247,143.257c-1.727,0.432-3.101,1.906-3.831,3.832l8.458-2.116 C454.662,143.533,452.974,142.825,451.247,143.257z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#422C4F"
    },
    cx: 452.06,
    cy: 150.087,
    rx: 1.293,
    ry: 1.706
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M469.648,144.176c2.279,0.432,4.092,1.906,5.055,3.832l-11.161-2.116 C465.143,144.453,467.369,143.744,469.648,144.176z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M466.87,151.007c0,0.942,0.764,1.706,1.706,1.706c0.942,0,1.706-0.764,1.706-1.706 c0-0.942-0.764-1.706-1.706-1.706C467.634,149.301,466.87,150.065,466.87,151.007z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M460.818,160.689c-0.007,0-0.015,0-0.021-0.001c-0.882-0.078-1.772-0.191-2.682-0.311 c-0.927-0.122-1.759-0.633-2.285-1.404c-0.514-0.751-0.684-1.684-0.469-2.559c0.708-2.88,1.658-5.727,2.824-8.459 c0.054-0.128,0.203-0.186,0.327-0.132c0.127,0.054,0.186,0.201,0.132,0.328c-1.154,2.708-2.096,5.528-2.797,8.382 c-0.185,0.748-0.044,1.515,0.396,2.158c0.445,0.653,1.151,1.087,1.936,1.19c0.905,0.119,1.789,0.232,2.66,0.309 c0.138,0.012,0.239,0.133,0.228,0.271C461.056,160.591,460.947,160.689,460.818,160.689z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.612,161.704c-4.145,0.485-8.29,0.97-12.436,1.454c1.535,1.993,4.023,3.283,6.53,3.064 C465.214,166.003,467.445,163.933,468.612,161.704z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5088BA"
    },
    d: "M483.329,281.833h-36.496l-56.412,15.406c-13.212,3.608-20.362,17.891-15.335,30.63L400,391 l24.498-9.616L415,328.965h21.833l46.496-30.298V281.833z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6CA7D3"
    },
    points: "427.145,380.345 397.353,392.039 400.583,402.694 430.375,391  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD6C67"
    },
    d: "M398.517,428.917c-0.456,1.348-0.706,2.779-0.706,4.25h40.356l-1.3-4.25H398.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C404C"
    },
    d: "M425.816,392.789l-19.649,7.713l4.877,12.881c0.918,2.424-0.169,5.148-2.504,6.274 l-3.225,1.556c-3.264,1.575-5.675,4.382-6.799,7.704h38.35L425.816,392.789z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#457BA3"
    },
    d: "M423.399,319.456l1.851,9.509h11.583l46.496-30.298v-9.792l-45.915,9.516 C427.763,300.391,421.515,309.782,423.399,319.456z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5088BA"
    },
    d: "M500.75,281.833l-47.602,12.765c-13.421,3.599-22.172,16.495-20.558,30.296L439.5,384H468 l2.25-58.75H491c20.434,0,37-16.565,37-37v-15.972L500.75,281.833z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.833,
    y: 384,
    style: {
      fill: "#6CA7D3"
    },
    width: 33.5,
    height: 10.167
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A64F5A"
    },
    d: "M465.833,394.167h-24.167v17.014c0,5.337-2.906,10.25-7.583,12.819 c-3.321,1.825-5.742,4.833-6.871,8.333h38.621V394.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF8D6D"
    },
    d: "M427.212,432.333c-0.461,1.429-0.712,2.939-0.712,4.486v0.347h39.333v-4.833H427.212z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#457BA3"
    },
    d: "M470.25,325.25l0.609-15.916l0,0c3.966,4.18,4.814,10.428,2.104,15.514l-0.214,0.402H470.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M465.833,384.25c-0.138,0-0.25-0.112-0.25-0.25v-61.25c0-0.138,0.112-0.25,0.25-0.25 c0.138,0,0.25,0.112,0.25,0.25V384C466.083,384.138,465.971,384.25,465.833,384.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M422.076,368.267c-0.119,0-0.224-0.085-0.246-0.205l-10.823-59.729 c-0.024-0.136,0.065-0.267,0.201-0.291c0.142-0.026,0.266,0.066,0.291,0.201l10.823,59.73 c0.024,0.136-0.065,0.267-0.201,0.291C422.105,368.266,422.091,368.267,422.076,368.267z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M416.665,380.595c-0.113,0-0.215-0.077-0.243-0.191l-15.498-63.845 c-0.032-0.134,0.05-0.269,0.185-0.302c0.134-0.032,0.269,0.051,0.302,0.185l15.498,63.845c0.032,0.134-0.05,0.269-0.185,0.302 C416.704,380.593,416.685,380.595,416.665,380.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M399.241,295.081c-0.11,0-0.211-0.073-0.241-0.185c-0.036-0.133,0.042-0.271,0.176-0.307 l47.592-12.998c0.134-0.035,0.271,0.043,0.307,0.176c0.036,0.133-0.042,0.27-0.176,0.307l-47.592,12.998 C399.285,295.078,399.263,295.081,399.241,295.081z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M436.519,358.75c-0.125,0-0.233-0.094-0.248-0.221l-3.929-33.606 c-1.616-13.822,7.301-26.963,20.742-30.566l39.562-10.608c0.134-0.034,0.271,0.043,0.306,0.177 c0.036,0.133-0.043,0.271-0.177,0.306l-39.563,10.608c-13.202,3.54-21.962,16.448-20.375,30.025l3.929,33.606 c0.017,0.138-0.082,0.262-0.219,0.277C436.538,358.749,436.528,358.75,436.519,358.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M494.926,181.333h-5.891c-1.524,3.83-4.424,7.119-8.094,9.009 c-4.738,2.44-10.632,2.494-15.413,0.141c-3.526-1.736-6.38-4.751-8.021-8.317h-12.342c-11.797,0-22.329,7.394-26.336,18.491 l-11.746,32.53L436.5,241l3.833-13.679l6.5,54.512h36.496L520,253.5L494.926,181.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M494.926,181.333h10.014c11.334,0,21.55,6.833,25.878,17.308l11.849,28.68l-28.049,10.689 L494.926,181.333z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M483.329,281.833L520,253.5l-5.382-15.49l23.717-9.038l7.323,21.32 c2.679,7.8-1.441,16.299-9.223,19.028l-35.685,12.513l-29.25,7.844L483.329,281.833z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "538.335,228.972 514.618,238.01 517.119,245.209 538.874,230.543  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M432.996,285.612l-3.496-33.841l4.891-11.331l-24.615-6.537l-2.722,9.441 c-1.579,5.477-1.384,11.314,0.558,16.674l10.721,29.599L432.996,285.612z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "409.776,233.902 434.391,240.44 431.931,246.139 409.312,235.51  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DD8C"
    },
    d: "M504.472,208.809l3.977,37.837c0.344,3.272-0.671,6.542-2.807,9.045l-22.313,26.142L520,253.5 L504.472,208.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DD8C"
    },
    d: "M440.333,227.321l-2.742-22.999l-2.273,11.629c-1.165,5.961,0.046,12.142,3.375,17.222l0,0 L440.333,227.321z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M514.618,238.26c-0.104,0-0.2-0.064-0.236-0.168l-11.705-33.688 c-0.045-0.13,0.023-0.273,0.154-0.318c0.131-0.043,0.272,0.024,0.318,0.154l11.705,33.688c0.045,0.13-0.023,0.273-0.154,0.318 C514.673,238.255,514.646,238.26,514.618,238.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M511.902,230.626c-0.1,0-0.196-0.062-0.234-0.162c-0.048-0.129,0.017-0.273,0.146-0.322 l23.914-9.019c0.124-0.049,0.272,0.016,0.322,0.146c0.048,0.129-0.017,0.273-0.146,0.322l-23.914,9.019 C511.962,230.621,511.932,230.626,511.902,230.626z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M499.34,269.713c-0.074,0-0.148-0.033-0.198-0.097c-0.084-0.109-0.064-0.267,0.045-0.352 l27.406-21.175c0.109-0.084,0.266-0.066,0.352,0.045c0.084,0.109,0.064,0.266-0.045,0.351l-27.406,21.176 C499.447,269.696,499.394,269.713,499.34,269.713z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M444.753,264.638c-0.125,0-0.233-0.094-0.248-0.221l-7.162-60.065 c-0.017-0.137,0.081-0.262,0.219-0.278c0.133-0.021,0.261,0.081,0.277,0.218l7.162,60.066 c0.017,0.137-0.081,0.261-0.219,0.277C444.772,264.637,444.763,264.638,444.753,264.638z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M437.609,237.292c-0.023,0-0.045-0.003-0.067-0.009c-0.133-0.037-0.211-0.175-0.174-0.308 l2.724-9.72c0.037-0.133,0.175-0.211,0.309-0.173c0.133,0.037,0.211,0.175,0.174,0.308l-2.724,9.72 C437.819,237.219,437.719,237.292,437.609,237.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M438.362,234.605c-0.021,0-0.041-0.003-0.062-0.008l-24.987-6.346 c-0.134-0.034-0.215-0.17-0.181-0.304c0.034-0.134,0.173-0.214,0.304-0.181l24.987,6.346c0.134,0.034,0.215,0.17,0.181,0.304 C438.576,234.53,438.475,234.605,438.362,234.605z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "182.819,355 187.736,355 189.051,366.788 183.818,363.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "189.051,366.788 197.402,441.667 192.485,441.667 183.818,363.961  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "146.153,365.479 154.651,441.667 149.734,441.667 140.921,362.652  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "140.067,355 144.984,355 146.153,365.479 140.921,362.652  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "121.566,355 126.483,355 125.283,365.754 120.646,363.249  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "111.899,441.667 120.646,363.249 125.283,365.754 116.816,441.667  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "78.814,355 83.731,355 82.612,365.031 77.975,362.526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "69.147,441.667 77.975,362.526 82.612,365.031 74.065,441.667  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797C99"
    },
    d: "M191.275,355l-0.001-0.002c-4.466-9.666-14.143-15.855-24.792-15.855h-32.541L116.347,224.62 l-24.722-19.995H75.969c-19.61,0-34.607,17.477-31.629,36.859l14.834,96.553C60.673,347.796,69.069,355,78.942,355H191.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M206.932,355l-0.001-0.002c-4.466-9.666-14.143-15.855-24.792-15.855h-32.541l-15.002-97.644 c-3.259-21.213-21.51-36.874-42.971-36.874h0c-19.61,0-34.607,17.477-31.629,36.859l13.179,85.785 c1.049,6.831,6.927,11.874,13.838,11.874h20.528c10.648,0,20.325,6.189,24.792,15.855l0.001,0.002H206.932z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#537496"
    },
    d: "M155.751,296.333l-16.527,42.81h82.777l-14.75,63.671h40l11.333-68.042 c2.661-15.977-8.748-30.872-24.867-32.465l-60.473-5.974H155.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M222.001,339.143l4.716-20.356l-5.988,5.366c-1.312,1.176-2.062,2.854-2.062,4.616l0,0 c0,3.13-2.334,5.769-5.441,6.151l-2.468,0.304l-0.653,3.919H222.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A64F5A"
    },
    d: "M242.76,427.361c-0.067-0.071-0.139-0.135-0.204-0.208l-0.897-1.004 c-2.156-2.413-3.108-5.671-2.588-8.865l2.429-14.469h-18.442l-2.328,14.066c-0.44,2.769-1.34,5.457-2.765,7.871 c-0.995,1.686-2.164,4.169-3.021,7.415h22.692C238.79,430.083,240.624,428.409,242.76,427.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECA85E"
    },
    d: "M252.316,431.022l-3.053-0.37c-2.49-0.301-4.785-1.472-6.503-3.292 c-2.137,1.048-3.97,2.722-5.124,4.806h-22.692c-0.399,1.512-0.737,3.175-0.947,5.029c-0.269,2.379,1.584,4.471,3.977,4.471 h43.776C261.75,436.243,257.701,431.674,252.316,431.022z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "223.058,402.814 241.5,402.814 241.131,405.082 222.1,408.84  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD6C67"
    },
    d: "M192.432,427.361c-0.067-0.071-0.139-0.135-0.204-0.208l-0.897-1.004 c-2.156-2.413-3.108-5.671-2.588-8.865l2.34-14.469h-18.442l-2.239,14.066c-0.44,2.769-1.34,5.457-2.765,7.871 c-0.995,1.686-2.164,4.169-3.021,7.415h22.692C188.462,430.083,190.296,428.409,192.432,427.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D071"
    },
    d: "M201.988,431.022l-3.053-0.37c-2.49-0.301-4.785-1.472-6.503-3.292 c-2.137,1.048-3.97,2.722-5.124,4.806h-22.692c-0.399,1.512-0.737,3.175-0.947,5.029c-0.269,2.379,1.583,4.471,3.977,4.471 h43.776C211.422,436.243,207.372,431.674,201.988,431.022z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "172.641,402.814 191.083,402.814 190.715,405.082 171.684,408.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6081A8"
    },
    d: "M108,296.333l-4.45,11.526c-5.818,15.069,5.303,31.284,21.457,31.284h49.243l-14.75,63.671h40 l11.537-69.266c2.584-15.516-8.116-30.116-23.691-32.323l-34.513-4.891H108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M174.25,339.143l4.716-20.356l-5.757,5.716c-3.847,3.819-5.384,9.389-4.042,14.64l0,0H174.25z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M174.25,339.393h-35.026c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h35.026 c0.138,0,0.25,0.112,0.25,0.25S174.388,339.393,174.25,339.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M161.622,393.906c-0.019,0-0.038-0.002-0.057-0.007c-0.134-0.031-0.218-0.165-0.187-0.3 l17.344-74.869c0.031-0.134,0.165-0.22,0.3-0.187c0.134,0.031,0.218,0.165,0.187,0.3l-17.344,74.869 C161.838,393.828,161.735,393.906,161.622,393.906z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M187.347,301.475c-0.012,0-0.023-0.001-0.036-0.003l-21.505-3.048 c-0.137-0.018-0.232-0.146-0.212-0.282c0.02-0.137,0.147-0.232,0.283-0.212l21.505,3.048 c0.137,0.019,0.232,0.145,0.212,0.282C187.576,301.385,187.469,301.475,187.347,301.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M200.821,395.137c-0.014,0-0.028-0.001-0.042-0.003c-0.136-0.023-0.229-0.152-0.206-0.288 l7.641-45.872c0.022-0.137,0.155-0.227,0.288-0.206c0.136,0.023,0.229,0.152,0.206,0.288l-7.641,45.872 C201.046,395.05,200.94,395.137,200.821,395.137z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A64F5A"
    },
    d: "M188.333,228.5l7,23.271l34.333,40.895L220.482,301L187.4,271.784 c-4.742-4.188-8.136-9.687-9.754-15.804L171.833,234L188.333,228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M188.333,228.5l-16.5,5.5l5.813,21.98c0.032,0.119,0.074,0.233,0.107,0.352l14.428-15.039 L188.333,228.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D071"
    },
    d: "M168.88,192.592L168.88,192.592c5.709-0.282,10.883,3.339,12.574,8.799l9.922,32.047 l-10.125,2.312l-6-17.25L168.88,192.592z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECA85E"
    },
    points: "175.25,218.5 181.25,235.75 190.01,233.75 172.8,208.535  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M175.307,164.079c3.892-5.547,7.405-11.531,8.836-18.154c1.431-6.623,0.528-14.019-3.697-19.317 c-4.225-5.298-12.144-7.799-18.169-4.698c-7.42-4.863-16.319-7.975-24.589-4.762c-8.27,3.213-14.799,10.584-16.991,19.181 c-4.418,17.33,8.101,36.042,2.413,52.998c-2.342,6.982-7.482,12.59-11.903,18.479c-4.421,5.89-8.369,12.837-7.666,20.168 c0.903,9.408,9.772,16.744,19.142,17.98c7.388,0.975,15.147-1.309,20.829-6.13c6.635-5.629,10.152-14.191,11.702-22.753 c1.55-8.562,1.366-17.329,1.923-26.012c0.349-5.432,1.018-10.951,3.286-15.9C162.692,170.211,170.045,165.47,175.307,164.079z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D071"
    },
    d: "M184.387,231.997L178,217.5l-9.12-24.908l-23.895,1.181 c-13.731,0.679-24.337,12.317-23.742,26.052l0.463,10.677l0,0l-1.326,27.026c-0.251,5.115-1.319,10.158-3.164,14.935 L108,296.333h65.244l4.548-30.256l0.796-8.843c0.268-2.974,1.439-5.794,3.357-8.082l0,0 C185.959,244.365,186.905,237.714,184.387,231.997z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M184.387,232.247c-0.096,0-0.188-0.056-0.229-0.149l-6.387-14.497l-5.021-13.713 c-0.047-0.129,0.019-0.273,0.149-0.321c0.129-0.047,0.273,0.02,0.321,0.149l5.016,13.698l6.381,14.482 c0.056,0.126-0.002,0.274-0.128,0.33C184.455,232.24,184.42,232.247,184.387,232.247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M158.494,249.338c-0.129,0-0.239-0.1-0.249-0.232c-0.01-0.138,0.093-0.258,0.231-0.268 c4.925-0.364,9.668-2.914,12.688-6.822c0.086-0.109,0.243-0.128,0.351-0.045c0.109,0.084,0.129,0.241,0.045,0.351 c-3.104,4.019-7.981,6.641-13.046,7.016C158.506,249.338,158.5,249.338,158.494,249.338z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD6C67"
    },
    d: "M144.625,174.75L144,194.375l3.106,3.19c5.045,5.182,13.758,3.42,16.394-3.315l0,0l-1.75-14.75 L144.625,174.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M156.779,189.707c2.058,0.317,4.197-0.047,6.069-0.957l-1.098-9.251l-17.125-4.75l-0.083,2.593 c0.984,2.324,2.087,4.593,3.586,6.615C150.244,186.811,153.268,189.167,156.779,189.707z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD6C67"
    },
    d: "M177.125,148v10.819c0,4.753-0.801,9.473-2.368,13.961l0,0 c-2.4,6.869-8.881,11.471-16.157,11.471l0,0c-4.247,0-8.343-1.579-11.491-4.431l-6.004-5.44 c-2.433-2.204-4.164-5.074-4.98-8.254l0,0c18.375-8,24.875-21.625,25.125-32.5C173.75,138.75,177.125,148,177.125,148z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M158.37,148.6c-2.575,0.488-4.622,2.153-5.71,4.329l12.609-2.39 C163.459,148.912,160.944,148.112,158.37,148.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M161.508,156.316c0,1.064-0.863,1.927-1.927,1.927s-1.927-0.863-1.927-1.927 s0.863-1.927,1.927-1.927S161.508,155.251,161.508,156.316z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M174.192,148.6c1.555,0.488,2.791,2.153,3.448,4.329l-7.614-2.39 C171.118,148.912,172.637,148.112,174.192,148.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M172.296,156.316c0,1.064,0.521,1.927,1.164,1.927s1.164-0.863,1.164-1.927 s-0.521-1.927-1.164-1.927S172.296,155.251,172.296,156.316z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M167.911,167.374c-0.525,0-1.043-0.052-1.529-0.101c-0.137-0.014-0.238-0.136-0.224-0.273 c0.013-0.138,0.138-0.236,0.273-0.224c0.95,0.095,1.932,0.194,2.846-0.074c0.798-0.232,1.662-0.875,1.79-1.788 c0.096-0.687-0.231-1.381-0.547-2.053l-0.084-0.178c-1.261-2.708-1.835-5.714-1.659-8.695 c0.008-0.138,0.124-0.245,0.264-0.235c0.138,0.008,0.243,0.126,0.235,0.264c-0.171,2.898,0.387,5.822,1.613,8.455 l0.083,0.176c0.348,0.738,0.707,1.501,0.59,2.335c-0.159,1.134-1.192,1.921-2.145,2.199 C168.924,167.326,168.414,167.374,167.911,167.374z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M170.393,170.453c-4.271,0.562-8.542,1.124-12.813,1.685c1.141,2.453,3.991,3.891,6.687,3.667 C166.964,175.582,169.673,173.061,170.393,170.453z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD6C67"
    },
    d: "M124.75,251.771l22.5-3.521l3.083,26.25l54.333-16.667l3.167,14.333l-53.064,24.189 c-12.747,5.811-27.364-2.945-28.255-16.926L124.75,251.771z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "147.25,248.25 124.75,251.771 125.339,261.01 147.536,250.682  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECA85E"
    },
    d: "M150.419,247.754l-27.374,4.284l-0.378-3.205l15.625-2.365 c4.796-0.726,8.154-5.122,7.593-9.939l-2.384-20.474c-0.552-4.743-3.269-8.963-7.358-11.43l0,0l0.333,0.125 c5.326,2.001,9.118,6.77,9.869,12.409L150.419,247.754z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M123.044,252.288c-0.121,0-0.227-0.088-0.247-0.211c-0.021-0.137,0.072-0.265,0.208-0.286 l27.132-4.246l-4.042-30.353c-0.74-5.559-4.46-10.236-9.709-12.208l-0.332-0.125c-0.129-0.048-0.195-0.192-0.146-0.322 c0.049-0.129,0.192-0.197,0.322-0.146l0.333,0.125c5.422,2.037,9.265,6.869,10.029,12.61l4.074,30.595 c0.018,0.135-0.075,0.259-0.21,0.28l-27.373,4.284C123.07,252.287,123.058,252.288,123.044,252.288z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M139.224,278.158c-0.107,0-0.206-0.069-0.239-0.177c-0.041-0.132,0.034-0.271,0.165-0.313 l57.415-17.612c0.132-0.035,0.272,0.034,0.312,0.166c0.041,0.132-0.034,0.271-0.165,0.313l-57.415,17.612 C139.273,278.154,139.249,278.158,139.224,278.158z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M359.692,159.833V183.5c0,7.18-5.82,13-13,13H344.5l-2,3.167H317l8.667-13.5L359.692,159.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A3649"
    },
    d: "M359.75,164.375l-5.875,8.125v8.75c0,4.971-4.029,9-9,9h-15.669 c-3.096,0-5.981-1.595-7.629-4.216c-16.165-25.699-11.984-45.143,5.923-42.534C342.875,121.25,382.125,147.75,359.75,164.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M357.376,167.658l-3.501,4.842v8.5c0.461,1.39,1.8,2.044,2.806,1.749 c1.006-0.295,1.859-1.312,2.548-2.465c0.868-1.453,1.549-3.205,1.798-5.13c0.249-1.924,0.031-4.027-0.735-5.606 C359.527,167.969,358.668,167.658,357.376,167.658z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M356.184,183.068c-0.284,0-0.578-0.056-0.861-0.166c-0.129-0.05-0.193-0.194-0.142-0.323 c0.05-0.129,0.195-0.193,0.323-0.143c0.376,0.146,0.77,0.171,1.107,0.072c0.803-0.236,1.612-1.028,2.403-2.354 c0.93-1.557,1.54-3.297,1.764-5.033c0.256-1.975-0.01-4.018-0.711-5.465c-0.417-0.859-0.864-1.343-1.45-1.568 c-0.129-0.05-0.193-0.194-0.144-0.323c0.049-0.128,0.193-0.192,0.323-0.143c0.713,0.274,1.244,0.834,1.72,1.817 c0.753,1.553,1.029,3.648,0.757,5.747c-0.233,1.803-0.866,3.61-1.831,5.226c-0.871,1.457-1.751,2.3-2.692,2.576 C356.571,183.042,356.38,183.068,356.184,183.068z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454F6B"
    },
    d: "M324.819,429.176c-1.645-1.992-2.937-4.25-3.82-6.677l-0.666-1.832h-20.773l-1.614,16.5 h31.118C328.202,434.254,326.766,431.532,324.819,429.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M329.064,437.167h-31.118l-0.44,4.5H330l-0.32-1.878 C329.529,438.9,329.319,438.026,329.064,437.167z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "320.333,420.667 299.561,420.667 298.938,427.029  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#984058"
    },
    points: "338.03,320 330.03,420.667 293.367,420.667 301.209,339.667  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#472948"
    },
    points: "334.03,370.333 299.217,360.239 301.209,339.667 338.03,320  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454F6B"
    },
    d: "M390.056,430.29L390.056,430.29c-3.511-1.709-6.426-4.437-8.363-7.828l-1.026-1.796H362 l-3.536,16.5h39.346C395.905,434.242,393.248,431.844,390.056,430.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M397.81,437.167h-39.346l-0.964,4.5H400l-0.058-0.171 C399.417,439.953,398.685,438.509,397.81,437.167z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "380.667,420.667 362,420.667 360.637,427.029  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#984058"
    },
    d: "M340.177,296.333l39.873,17.642c8.157,3.609,13.144,11.977,12.437,20.868l-6.82,85.824 h-36.662l7.841-81l-23.521-2.63H274.89v-40.703H340.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472948"
    },
    d: "M356.846,339.667H382.5l-1.599,1.184c-7.058,5.228-16.185,6.78-24.575,4.181l0,0 L356.846,339.667z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M382.5,410.917h-29.167c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25H382.5 c0.138,0,0.25,0.112,0.25,0.25S382.638,410.917,382.5,410.917z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M327.113,410.917h-29.167c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h29.167 c0.138,0,0.25,0.112,0.25,0.25S327.251,410.917,327.113,410.917z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M380.667,416.75c-0.007,0-0.015,0-0.021-0.001c-0.138-0.012-0.239-0.134-0.228-0.271 l6.166-70.232c0.012-0.138,0.131-0.245,0.27-0.228c0.138,0.012,0.239,0.134,0.228,0.271l-6.166,70.232 C380.904,416.652,380.796,416.75,380.667,416.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M408.625,225.25l-8.958-15.917l0,0c1.926-0.889,4.208-0.401,5.602,1.199l2.732,3.135 L408.625,225.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M404.625,230.625l4-5.375l-2-11.75c-0.186-9.306,3.854-14.178,5.931-16.06 c0.645-0.585,1.599-0.664,2.318-0.173l0.023,0.016c0.859,0.586,1.052,1.747,0.474,2.612c-3.068,4.597-3.372,9.355-3.372,9.355 c2.343-4.777,5.921-7.604,7.735-8.81c0.659-0.438,1.518-0.404,2.149,0.074l5.562,4.214c0.848,0.643,0.99,1.865,0.301,2.677 c-2.86,3.37-4.372,8.095-4.372,8.095c2,7.875-1.75,13.125-3.375,14l-6.5,10.375L404.625,230.625z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CA8BC"
    },
    d: "M271.999,223.5L271.999,223.5c3.558-15.786,17.581-27,33.763-27h33.758 c13.883,0,26.371,8.44,31.548,21.322L384,250l18.667-21.667C416,229,418.333,242.667,418.333,242.667l-25.638,32.759 c-7.427,9.49-22.283,7.674-27.205-3.327L354,246.417l-10.5,54.25c-15.833,9.333-62.169,7-71.501,2V223.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#468097"
    },
    points: "354,246.417 358.709,222.089 359.692,259.138  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#468097"
    },
    d: "M384,250l5.782,14.388l0.551-7.628c0.264-3.65-1.108-7.228-3.744-9.766l0,0L384,250z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M416.419,210.928c-0.04,0-0.08-0.009-0.117-0.029c-0.122-0.064-0.168-0.216-0.104-0.338 c1.593-3.008,3.845-5.716,6.512-7.831c0.108-0.085,0.265-0.069,0.352,0.04c0.085,0.108,0.067,0.266-0.041,0.351 c-2.613,2.072-4.819,4.725-6.381,7.673C416.595,210.879,416.509,210.928,416.419,210.928z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M420.602,212.048c-0.044,0-0.089-0.012-0.13-0.036c-0.117-0.071-0.155-0.225-0.084-0.343 c1.354-2.238,3.02-4.268,4.95-6.034c0.102-0.092,0.26-0.087,0.354,0.016c0.093,0.102,0.086,0.26-0.016,0.353 c-1.895,1.733-3.53,3.726-4.86,5.923C420.769,212.005,420.685,212.048,420.602,212.048z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M407.084,227.571c-0.052,0-0.105-0.016-0.149-0.049c-0.11-0.083-0.134-0.239-0.051-0.35 l1.477-1.985l-1.522-8.95c-0.023-0.136,0.068-0.265,0.204-0.288c0.146-0.025,0.266,0.068,0.288,0.204l1.541,9.056 c0.012,0.067-0.005,0.136-0.046,0.191l-1.541,2.071C407.235,227.537,407.16,227.571,407.084,227.571z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M345.867,288.691c-0.016,0-0.032-0.001-0.048-0.005c-0.136-0.026-0.224-0.157-0.198-0.293 l12.842-66.352c0.026-0.136,0.158-0.224,0.293-0.198c0.136,0.026,0.224,0.158,0.198,0.293l-12.842,66.353 C346.088,288.608,345.984,288.691,345.867,288.691z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M389.782,264.638c-0.099,0-0.192-0.06-0.232-0.157l-15.728-39.137 c-0.052-0.128,0.011-0.274,0.139-0.325c0.129-0.052,0.274,0.01,0.325,0.139l15.729,39.138c0.051,0.128-0.011,0.273-0.14,0.325 C389.845,264.632,389.814,264.638,389.782,264.638z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M384,250.25c-0.058,0-0.116-0.02-0.163-0.061c-0.104-0.09-0.116-0.248-0.026-0.353 l10.955-12.716c0.091-0.104,0.249-0.116,0.353-0.026c0.104,0.09,0.116,0.248,0.026,0.353l-10.955,12.716 C384.14,250.221,384.07,250.25,384,250.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M325.965,295.614c-0.024,0-0.048-0.003-0.072-0.011c-7.302-2.193-14.064-6.147-19.556-11.435 c-0.1-0.096-0.103-0.254-0.007-0.354c0.097-0.099,0.255-0.101,0.353-0.006c5.435,5.231,12.127,9.145,19.353,11.315 c0.132,0.039,0.207,0.179,0.167,0.311C326.172,295.544,326.073,295.614,325.965,295.614z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M319.897,224.266c-0.104,0-0.2-0.064-0.236-0.168c-0.046-0.13,0.023-0.272,0.154-0.318 l9.655-3.366c0.131-0.047,0.273,0.023,0.318,0.153c0.046,0.13-0.023,0.273-0.153,0.318l-9.656,3.366 C319.952,224.262,319.924,224.266,319.897,224.266z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M342.859,350.483c-1.257-8.857-8.828-15.447-17.774-15.47l-5.098-0.013 c-3.815-0.01-7.092-2.713-7.829-6.456l-16.482-83.783c-4.83-24.555-26.359-42.26-51.384-42.26l0,0h-16.589l2.644,2.644 c-16.454,6.489-27.003,24.072-23.34,42.691l17.43,88.605c2.121,10.784,11.576,18.56,22.567,18.56H343.5L342.859,350.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797C99"
    },
    d: "M207.849,336.44l-17.43-88.605c-4.619-23.481,13.354-45.335,37.285-45.335h0 c25.025,0,46.553,17.706,51.384,42.26l18.035,91.679c2.121,10.784,11.577,18.56,22.567,18.56h0.81h-90.084 C219.425,355,209.97,347.224,207.849,336.44z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "235.333,355 230.416,355 229.101,366.788 234.334,363.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "229.101,366.788 220.75,441.667 225.667,441.667 234.334,363.961  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "271.999,365.479 263.501,441.667 268.418,441.667 277.231,362.652  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "278.085,355 273.168,355 271.999,365.479 277.231,362.652  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "296.586,355 291.669,355 292.869,365.754 297.506,363.249  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "306.253,441.667 297.506,363.249 292.869,365.754 301.336,441.667  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "339.338,355 334.421,355 335.54,365.031 340.177,362.526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "349.004,441.667 340.177,362.526 335.54,365.031 344.087,441.667  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M596.337,209.649l8.875-11.367c2.233-2.86,5.66-4.532,9.289-4.532l-1.942-0.343 c-1.425-0.251-2.604-1.253-3.081-2.619l-5.102-14.6l-15.042,7.979l2.202,11.597c0.191,1.008-0.012,2.051-0.568,2.913 l-9.192,14.261l0.173,0.083C586.942,215.417,592.929,214.014,596.337,209.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E68799"
    },
    d: "M625.667,304.265L614.5,193.75c-3.629,0-7.055,1.672-9.289,4.532l-8.875,11.367 c-3.408,4.365-9.395,5.768-14.387,3.371l-0.173-0.083l-14.947,23.191c-1.953,3.031-2.203,6.922-0.446,10.071 c0.871,1.562,1.921,2.873,3.005,3.961c4.092,4.107,5.723,10.068,4.641,15.763L569.833,288L625.667,304.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M590.747,191.614c12.135-3.838,14.037-11.443,13.628-15.426l-15.042,7.979L590.747,191.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E36B85"
    },
    d: "M608.112,216.101l-1.752,49.877c-0.203,5.765-4.824,10.394-10.589,10.606l-23.936,0.881 L569.833,288l55.833,16.265l-8.908-88.164H608.112z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M592.362,253.676c-0.021,0-0.041-0.003-0.062-0.008c-4.984-1.268-9.57-4.386-12.583-8.554 c-0.08-0.112-0.056-0.268,0.057-0.349c0.11-0.082,0.267-0.056,0.35,0.056c2.944,4.075,7.427,7.124,12.3,8.363 c0.134,0.034,0.215,0.17,0.181,0.304C592.576,253.601,592.474,253.676,592.362,253.676z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA25D"
    },
    d: "M619.234,140.88c2.499-9.691,11.75-17.226,21.746-17.711c3.702-0.18,7.68,0.65,10.266,3.305 c2.188,2.245,3.07,5.467,3.347,8.59c0.492,5.534-0.655,11.072-1.909,16.484c-1.254,5.412-2.631,10.865-2.61,16.42 c0.021,5.555,1.612,11.337,5.532,15.274c-10.21,1.702-20.941-3.377-27.043-11.738 C622.461,163.143,616.649,150.903,619.234,140.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA25D"
    },
    d: "M578.292,163.207c-3.519-3.846-5.772-8.833-6.332-14.016c-0.371-3.43,0.003-6.988,1.448-10.12 c1.445-3.132,4.023-5.803,7.255-7.008c3.232-1.206,7.102-0.808,9.814,1.324c5.016-3.045,11.201-3.845,16.919-2.526 c5.718,1.319,10.869,4.943,14.043,9.878c3.934,6.117,4.711,13.987,2.774,20.997c-1.853,6.705-6.472,12.985-13.066,15.201 c-5.671,1.907-12.031,0.582-17.313-2.227C588.552,171.899,582.331,167.621,578.292,163.207z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M611.147,177.186c-0.104,0-0.202-0.066-0.237-0.17c-0.044-0.131,0.026-0.272,0.157-0.316 c5.952-2.001,10.896-7.76,12.905-15.031c2-7.24,0.975-15.014-2.743-20.795c-3.151-4.899-8.214-8.46-13.89-9.77 c-0.134-0.031-0.218-0.165-0.187-0.3c0.031-0.134,0.162-0.217,0.3-0.188c5.801,1.339,10.976,4.979,14.196,9.987 c3.794,5.899,4.843,13.824,2.806,21.199c-2.053,7.429-7.121,13.319-13.228,15.371 C611.201,177.182,611.174,177.186,611.147,177.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M585.333,144.833L585.333,144.833c-5.054,4.059-8.485,9.796-9.671,16.169l-0.496,2.664 l-5.5,8.833h5.833l0.823,8.647c0.311,3.269,2.479,6.066,5.567,7.183l0,0c2.075,0.751,4.36,0.665,6.373-0.24l11.273-5.067 c2.514-1.13,4.13-3.629,4.13-6.385v-5.305c-1.964-0.849-4.588-2.29-5.472-4.238s-1.016-4.226-0.362-6.263 C592.354,157.404,587.548,150.905,585.333,144.833z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M606.35,165.127c1.023-0.542,2.195-0.863,3.344-0.718c1.149,0.145,2.264,0.803,2.788,1.836 c0.508,1.002,0.416,2.202,0.173,3.299c-0.414,1.869-1.232,3.647-2.383,5.177c-0.837,1.113-1.882,2.117-3.175,2.633 c-1.293,0.516-2.864,0.475-3.983-0.353c-1.908-1.409-1.318-4.255-0.903-6.225 C602.708,168.412,604.195,166.268,606.35,165.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M605.351,175.693c-0.293,0-0.713-0.052-1.049-0.3c-0.882-0.652-0.432-2.79-0.135-4.205 c0.393-1.862,1.559-3.467,3.119-4.295c0.642-0.34,1.28-0.52,1.846-0.52c0.104,0,0.208,0.006,0.311,0.019 c0.558,0.07,1.062,0.374,1.256,0.757c0.202,0.399,0.203,1.059,0.004,1.961c-0.351,1.586-1.052,3.11-2.028,4.407 c-0.75,0.998-1.53,1.663-2.319,1.978C606.034,175.625,605.686,175.693,605.351,175.693z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M584.229,157.723c2.279,0.432,4.092,1.906,5.055,3.832l-11.162-2.116 C579.724,157.999,581.95,157.29,584.229,157.723z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#422C4F"
    },
    cx: 583.157,
    cy: 164.553,
    r: 1.706
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M587.663,177.348c-3.283-0.735-6.729-0.736-10.012-0.001c0.239,1.107,1.284,2.21,2.226,2.84 c0.941,0.63,2.13,0.878,3.245,0.677C584.827,180.557,586.446,178.583,587.663,177.348z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M550.644,282.41l65.542,19.094c11.276,3.285,22.406-5.581,21.726-17.306l-1.97-33.975 L613,253.5l1.75,29.375l-48.233-6.08c-4.068-0.513-8.184,0.462-11.591,2.745L550.644,282.41"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M613,253.5l22.943-3.277l0.514,8.868c-9.873,2.409-23.164-0.677-23.164-0.677L613,253.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E68799"
    },
    d: "M614.5,193.75L614.5,193.75c10.028,0,18.517,7.402,19.881,17.337L640,252 c-11.5,5.25-29.149,5-29.149,5l-2.739-40.899c-0.514-7.677,1.568-15.304,5.912-21.655L614.5,193.75z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#422C4F",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M614.5,193.75"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M610.433,251.005c-0.131,0-0.24-0.102-0.249-0.234l-2.321-34.653 c-0.281-4.186,0.196-8.344,1.417-12.359c0.041-0.132,0.185-0.206,0.311-0.167c0.133,0.04,0.207,0.18,0.167,0.312 c-1.203,3.957-1.673,8.055-1.397,12.18l2.321,34.653c0.01,0.138-0.095,0.257-0.232,0.266 C610.443,251.004,610.438,251.005,610.433,251.005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M638.882,244.107c-0.123,0-0.23-0.091-0.248-0.216l-4.501-32.77 c-0.019-0.137,0.077-0.263,0.214-0.282c0.147-0.018,0.264,0.078,0.282,0.213l4.501,32.77c0.018,0.137-0.077,0.263-0.214,0.282 C638.904,244.106,638.893,244.107,638.882,244.107z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M623.618,284.243c-0.01,0-0.02-0.001-0.031-0.002l-47.709-6.014 c-0.137-0.018-0.234-0.143-0.217-0.279c0.017-0.136,0.129-0.234,0.279-0.217l47.709,6.014 c0.137,0.018,0.234,0.143,0.217,0.279C623.851,284.15,623.742,284.243,623.618,284.243z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M620.877,251.136c-0.12,0-0.226-0.086-0.246-0.207c-0.023-0.136,0.067-0.265,0.203-0.289 c3.141-0.544,6.125-1.873,8.63-3.844c0.108-0.085,0.266-0.067,0.351,0.042c0.086,0.109,0.066,0.266-0.042,0.351 c-2.569,2.022-5.631,3.386-8.853,3.944C620.905,251.135,620.891,251.136,620.877,251.136z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M476.201,395.456l2.157-9.097l6.153-15.146l-16.676-6.775l-3.351,8.247 c-1.503,3.698-4.485,6.551-8.167,7.931c0.743,2.287,1.051,4.716,0.871,7.115L476.201,395.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E68799"
    },
    d: "M457.188,387.732c0.18-2.398-0.128-4.828-0.871-7.115c-0.618,0.232-1.251,0.434-1.905,0.579 l-1.565,0.347c-1.995,0.442-4.062,0.449-6.06,0.018l-2.528-0.545c-5.259-1.133-10.707,0.806-14.067,5.007l44.007,17.879 l2.003-8.447L457.188,387.732z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "467.835,364.439 484.511,371.214 482.158,377.004 467.082,366.292  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4893D8"
    },
    points: "462.205,362.726 494.75,297.25 520.575,310.521 500.167,379.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4893D8"
    },
    d: "M625.667,304.265l-98.133-28.588c-11.154-3.249-23.033,1.957-28.204,12.36l-4.579,9.213l72,37 h31.712c14.336,0,26.172-11.203,26.959-25.517L625.667,304.265z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M595.435,295.708c-0.023,0-0.047-0.003-0.07-0.01l-63.756-18.573 c-0.132-0.039-0.208-0.178-0.17-0.31c0.039-0.132,0.178-0.208,0.311-0.17l63.756,18.573c0.132,0.039,0.208,0.178,0.17,0.31 C595.643,295.637,595.543,295.708,595.435,295.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M625.667,304.516c-0.023,0-0.047-0.003-0.07-0.01l-19.907-5.8 c-0.132-0.039-0.208-0.178-0.17-0.311c0.039-0.132,0.18-0.209,0.311-0.17l19.907,5.8c0.132,0.039,0.208,0.178,0.17,0.311 C625.875,304.444,625.775,304.516,625.667,304.516z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4893D8"
    },
    d: "M516.134,308.239l-11.29,2.047c-9.579,1.737-16.708,9.829-17.224,19.551L483.5,407.5h44.75 l-6.5-70l45-3.25L516.134,308.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#377FB5"
    },
    d: "M512.834,308.837c0,0,32.391,26.967,32.355,26.97c-0.036,0.003,21.561-1.557,21.561-1.557 l-50.616-26.011L512.834,308.837z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M488.943,323.776c-0.029,0-0.06-0.005-0.089-0.017c-0.129-0.049-0.193-0.192-0.145-0.322 c2.623-6.94,8.788-12.073,16.089-13.397l11.29-2.047c0.143-0.027,0.266,0.066,0.291,0.201 c0.024,0.136-0.065,0.267-0.201,0.291l-11.29,2.047c-7.13,1.293-13.149,6.306-15.712,13.083 C489.14,323.715,489.044,323.776,488.943,323.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M521.75,337.75c-0.13,0-0.24-0.101-0.249-0.232c-0.011-0.138,0.094-0.257,0.231-0.267 l36.739-2.653c0.131-0.03,0.257,0.094,0.267,0.231c0.011,0.138-0.094,0.257-0.232,0.267l-36.739,2.653 C521.762,337.75,521.756,337.75,521.75,337.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M484.926,380.867c-0.004,0-0.009,0-0.014,0c-0.138-0.008-0.243-0.125-0.236-0.264l2.46-46.367 c0.008-0.133,0.118-0.236,0.25-0.236c0.004,0,0.009,0,0.014,0c0.138,0.008,0.243,0.125,0.236,0.264l-2.46,46.367 C485.168,380.764,485.058,380.867,484.926,380.867z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M524.835,370.972c-0.128,0-0.237-0.098-0.249-0.227l-4.038-43.487 c-0.013-0.138,0.089-0.26,0.225-0.272c0.139-0.023,0.26,0.089,0.273,0.225l4.038,43.487c0.013,0.138-0.089,0.26-0.226,0.272 C524.851,370.972,524.843,370.972,524.835,370.972z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M512.926,433.087l-1.426-9.239V407.5h-18v8.902c0,3.992-1.689,7.757-4.581,10.422 c1.549,1.839,2.749,3.974,3.485,6.263H512.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E68799"
    },
    d: "M492.404,433.087c-0.736-2.29-1.936-4.424-3.485-6.263c-0.486,0.448-0.995,0.873-1.547,1.254 l-1.319,0.911c-1.682,1.161-3.594,1.944-5.607,2.298l-2.547,0.447c-5.299,0.93-9.616,4.777-11.148,9.934h47.5l-1.324-8.579 H492.404z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "493.5,407.5 511.5,407.5 511.5,413.75 493.5,409.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "658.462,352.458 663.379,352.458 664.694,364.247 659.461,361.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "664.694,364.247 673.045,439.125 668.128,439.125 659.461,361.42  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "626.851,362.937 635.349,439.125 630.432,439.125 621.619,360.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "620.765,352.458 625.682,352.458 626.851,362.937 621.619,360.111  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "610.831,352.458 615.748,352.458 614.549,363.213 609.911,360.707  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "601.164,439.125 609.911,360.707 614.549,363.213 606.081,439.125  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "570.268,352.458 575.185,352.458 574.066,362.49 569.428,359.984  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99A3B0"
    },
    points: "560.601,439.125 569.428,359.984 574.066,362.49 565.518,439.125  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797C99"
    },
    d: "M691.583,207.761v-7.803h-16.798h-0.001c-19.841,0-36.909,14.038-40.739,33.506l-16.787,85.333 c-1.476,7.502-8.053,12.912-15.699,12.912h-21.486c-11.46,0-20.75,9.29-20.75,20.75l0,0h93.295 c10.991,0,20.446-7.776,22.567-18.56l21.186-107.693C697.729,219.302,695.709,212.645,691.583,207.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M691.984,333.898l21.185-107.693c2.674-13.594-7.732-26.247-21.586-26.247h-0.001 c-19.841,0-36.91,14.038-40.739,33.506l-19.758,100.434c-2.122,10.784-11.577,18.56-22.568,18.56h-0.81h61.708 C680.408,352.458,689.863,344.682,691.984,333.898z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe);
export default __webpack_public_path__ + "static/media/groupe.4e6e6b4289e91e690db8061ca1ef110b.svg";
export { ForwardRef as ReactComponent };